module.exports = __webpack_public_path__ + "static/media/cu.1f1e7f63.svg";